import React from 'react';

type Props<T extends string> = {
  label: string;
  name: string;
  options: readonly T[];
  selectedValue: T;
  onChange: (value: T) => void;
};

export const RadioGroup = <T extends string>({ 
  label, 
  name, 
  options, 
  selectedValue, 
  onChange 
}: Props<T>) => {
  return (
    <div className="flex items-center gap-[16px]">
      <label className="text-[14px] text-primary noto-sans-jp-medium">
        {label}
      </label>
      <div className="flex gap-[16px]">
        {options.map((option) => (
          <label key={option} className="flex items-center gap-[8px] cursor-pointer">
            <input
              type="radio"
              name={name}
              value={option}
              checked={selectedValue === option}
              onChange={() => onChange(option)}
              className="w-[16px] h-[16px]"
            />
            <span className="text-[14px] text-textPrimary noto-sans-jp-regular">
              {option}
            </span>
          </label>
        ))}
      </div>
    </div>
  );
}; 